import { render, staticRenderFns } from "./gameStageBackview.vue?vue&type=template&id=324d6bc0&scoped=true&"
import script from "./gameStageBackview.vue?vue&type=script&lang=js&"
export * from "./gameStageBackview.vue?vue&type=script&lang=js&"
import style0 from "./gameStageBackview.vue?vue&type=style&index=0&id=324d6bc0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324d6bc0",
  null
  
)

export default component.exports